import { ShareValues } from './ShareValues';
export var isFeatureEnabled = function (feature) {
    var _a = ShareValues.getData(), application = _a.application, centralProfile = _a.centralProfile;
    var app = centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.applications.find(function (a) { return a.app_key === application; });
    var features = app === null || app === void 0 ? void 0 : app.features;
    if (features && features.hasOwnProperty(feature)) {
        return features[feature];
    }
    return false;
};
//# sourceMappingURL=isFeatureEnabled.js.map